export default "__VITE_ASSET__DAVtRbeA__"